import { SET_APPROVAL_INFO } from '../actions';

export const setApprovalInfo = (approvalInfo = {}) => ({
  type: SET_APPROVAL_INFO,
  payload: approvalInfo,
});
